import React from "react";
import ReactDOM from "react-dom/client";
import 'leaflet/dist/leaflet.css';
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from '@/serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for offline support (FM operations)
serviceWorkerRegistration.register();
